import React from 'react'

import { Box, Button } from '@material-ui/core'

import { useWindowSize } from 'hooks'

const Footer = ({
  prevButtonText = 'Voltar',
  prevButtonProps = {},
  nextButtonText = 'Continuar',
  nextButtonProps = {},
}) => {
  const windowSize = useWindowSize()

  return (
    <Box
      display="flex"
      flexDirection={{ xs: 'column', sm: 'row-reverse' }}
      alignItems="center"
      justifyContent={{ xs: 'center', sm: 'space-between' }}
    >
      <Box width={{ xs: '100%', sm: 'auto' }} mb={{ xs: 1, sm: 0 }}>
        <Button
          variant="contained"
          color="primary"
          fullWidth={!windowSize.isDesktop}
          {...nextButtonProps}
        >
          {nextButtonText}
        </Button>
      </Box>

      <Button
        variant="outlined"
        color="primary"
        fullWidth={!windowSize.isDesktop}
        {...prevButtonProps}
      >
        {prevButtonText}
      </Button>
    </Box>
  )
}

export default Footer
